export default __webpack_public_path__ + "static/media/rifles-3.c11d662b.svg";